module.exports = __webpack_public_path__ + "static/media/logo_sample_dark.1c6ef589.png";